module.exports = __webpack_public_path__ + "static/media/star.4665b1e4.svg";